import { useNavigate } from 'react-router-dom';
import { ArrowRight, UserPlus } from 'react-feather';
import TablaServidor from '../../components/tabla/TablaServidor';
import { useTituloCabecera } from '../../context/tituloCabeceraContext';
import colors from '../../theme/colors';
import { COLUMNAS_PROFESORES, TABLA_PROFESORES } from '../../components/grupos/columnasGrupos';

const ListadoProfesores = () => {
  useTituloCabecera('Profesores', 'Gestiona y busca profesores del sistema');
  const navigate = useNavigate();

  const abrir = (f) => navigate(`/profesores/${f.empresaId}/${f.codigo}/detalles`);

  const nuevo = (
    <button
      type="button"
      onClick={() => navigate('/profesores/nuevo')}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '7px 14px',
        fontSize: '0.8125rem',
        fontWeight: 600,
        borderRadius: 8,
        border: 0,
        cursor: 'pointer',
        background: colors.primary,
        color: '#fff',
      }}
    >
      <UserPlus size={14} />
      Nuevo
    </button>
  );

  return (
    <TablaServidor
      tablaKey={TABLA_PROFESORES}
      columnas={COLUMNAS_PROFESORES}
      ruta="listado-profesores"
      archivo="profesores"
      nombreEntidad="profesores"
      placeholder="Buscar por nombre, apellidos, email, móvil o código…"
      barraExtra={nuevo}
      claveFila={(f) => `${f.empresaId}-${f.codigo}`}
      onFilaClick={abrir}
      renderAcciones={(f) => (
        <button
          type="button"
          className="tbl-icono"
          aria-label="Detalles"
          title="Ver detalles"
          onClick={(e) => {
            e.stopPropagation();
            abrir(f);
          }}
        >
          <ArrowRight size={15} />
        </button>
      )}
      tituloTarjeta={(f) => `${f.nombre || ''} ${f.apellidos || ''}`.trim() || `#${f.codigo}`}
    />
  );
};

export default ListadoProfesores;
